import { render, staticRenderFns } from "./IconPre.vue?vue&type=template&id=8ef8194e&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ef8194e')) {
      api.createRecord('8ef8194e', component.options)
    } else {
      api.reload('8ef8194e', component.options)
    }
    module.hot.accept("./IconPre.vue?vue&type=template&id=8ef8194e&", function () {
      api.rerender('8ef8194e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/IconPre.vue"
export default component.exports